import { LgaDto } from '@cradua/data';
import { createReducer, on, Action } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';

import * as LgaActions from './lga.actions';

export const LGA_FEATURE_KEY = 'lga';

export interface LgaState extends EntityState<LgaDto> {
  selectedLgaId?: string | number; // which Lga record has been selected
  loaded: boolean; // has the Lga list been loaded
  error?: string | null; // last none error (if any)
}

export interface LgaPartialState {
  readonly [LGA_FEATURE_KEY]: LgaState;
}

export const lgaAdapter: EntityAdapter<LgaDto> = createEntityAdapter<
  LgaDto
>({
  selectId: (lga) => lga.id,
  sortComparer: false,
});

export const initialState: LgaState = lgaAdapter.getInitialState({
  // set initial required properties
  loaded: false,
  error: null,
  selectedLgaId: null,
});

const lgaReducer = createReducer(
  initialState,
  on(LgaActions.loadLga, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(LgaActions.loadLgaSuccess, (state, { lga }) =>
    lgaAdapter.addAll(lga, { ...state, loaded: false })
  ),
  on(LgaActions.loadLgaFailure, (state, { error }) => ({
    ...state,
    loaded: false,
    error,
  })),
  on(LgaActions.addLga, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(LgaActions.addLgaSuccess, (state, { newLga }) =>
    lgaAdapter.addMany(newLga, { ...state, loaded: false })
  ),
  on(LgaActions.addLgaFailure, (state, { error }) => ({
    ...state,
    loaded: false,
    error,
  })),
  on(LgaActions.updateLga, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(LgaActions.updateLgaSuccess, (state, { updateLga }) =>
    lgaAdapter.upsertMany(updateLga, { ...state, loaded: false })
  ),
  on(LgaActions.updateLgaFailure, (state, { error }) => ({
    ...state,
    loaded: false,
    error,
  })),
  on(LgaActions.removeLga, (state) => ({
    ...state,
    loaded: true,
    error: null,
  })),
  on(LgaActions.removeLgaSuccess, (state, { ids }) =>
    lgaAdapter.removeMany(ids, { ...state, loaded: false })
  ),
  on(LgaActions.removeLgaFailure, (state, { error }) => ({
    ...state,
    loaded: false,
    error,
  }))
);

export function reducer(state: LgaState | undefined, action: Action) {
  return lgaReducer(state, action);
}
